import React from 'react'

const Ships = ({ ships, selectShip, selected }) => {
    return (
       
                <div className="card card-left-doc-aside bsn">
                    <div className="card-body pdl0 pdr0">
                        <div className="table-responsive bg-bd">
                            <table className="table align-middle table-nowrap table-hover mrb0">
                                <thead className="table-light">
                                    <tr>
                                        {/* <th scope="col" style={{ width: 70 }}>#</th> */}
                                        <th scope="col">Hull's</th>
                                        <th scope="col">Documents</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ships?.length > 0 ? (
                                        ships.map((item, index) => (
                                            <tr
                                                key={item.SHIP_ID || index}
                                                onClick={() => selectShip(index)}
                                                className={index === selected ? 'active' : ''}
                                            >

                                                <td>
                                                    <h5 className="font-size-14 mb-1">
                                                        <a href="javascript:void(0);" className="text-dark">
                                                            {item.HULL_NUMBER} - {item.SHIP_NAME}
                                                        </a>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <a href="javascript:void(0);" className="text-dark">
                                                        <span style={{ color: "#676767" }}>
                                                            {item.CLAIM_COUNT ?? 0}
                                                        </span>
                                                    </a>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            
    )
}

export default Ships